import React from "react";
import PageTitle from "components/PageTitle";
import {
    introTranslation,
    titleTranslation,
} from "data/contact/translationContact";
import { useLanguagesContext } from "hooks/useContextAll";
import PageDirection from "components/PageDirection";
import SocialLinks from "./SocialLinks";
import ContactField from "./ContactField";
// import ContactForm from "./ContactForm";

const ContactView = () => {
    const language = useLanguagesContext();

    return (
        <>
            <PageTitle text={titleTranslation[language.language]} />
            <PageDirection>
                <h3
                    className="page-intro animate-fade-up"
                    dangerouslySetInnerHTML={{
                        __html: introTranslation[language.language],
                    }}
                ></h3>
                <div className="contact-sides animate-fade-up">
                    <div className="links-side">
                        <SocialLinks />
                    </div>
                    <div className="form-side">
                        <ContactField />
                    </div>
                </div>
            </PageDirection>
        </>
    );
};

export default ContactView;
